import layout from "./layoutReducer";
import project from "@/components/partials/app/projects/store";

const rootReducer = {
  layout,
  project,
};
export default rootReducer;
